import { Button } from "@tennr/frontend/components/Button/Button";
import { FeatureCardCopy } from "@tennr/frontend/components/FeatureCardCopy/FeatureCardCopy";
import { IllustratedCard } from "@tennr/frontend/components/IllustratedCard/IllustratedCard";
import { Link } from "@tanstack/react-router";
import "./HowSection.css";
import { FC } from "react";
import { Heading } from "@tennr/frontend/components/Heading";
import { useMobile } from "@tennr/frontend/hooks/useMobile";

export const HowSection: FC = () => {
  const isMobile = useMobile();
  const headingText = isMobile
    ? "No delays.\nFewer denials. \nEveryone's\nlooped in."
    : "No delays. \nFewer denials.\nEveryone's looped in.";

  return (
    <section className="feature-cards section-y">
      <Heading
        title="THE BOTTOM LINE"
        heading={headingText}
        body="Tennr streamlines the pre-visit process so you can run a high-performance pipeline and get paid faster."
        variant="section"
        position="center"
        width={480}
      />
      <div className="cards-wrapper">
        <IllustratedCard
          heading="Convert more referrals"
          body="Solve document review, information gaps, and referring provider visibility without asking more of your team."
          image="/img/illustration-conversion.png"
          lottiePath="/lottie/HP_convertmorereferrals.lottie"
        />
        <IllustratedCard
          heading="Slash first-pass denials"
          body="Run a unified process from eligibility to benefits investigation and ensure you get paid for the work you do."
          image="/img/illustration-conversion.png"
          lottiePath="/lottie/HP_slashfirst.lottie"
        />
        <IllustratedCard
          heading="Keep referrers happy"
          body="Receive patients however they're sent — eFax, email, and e-portal — all while providing complete visibility to referral sources."
          lottiePath="/lottie/HP_referrers.lottie"
        />
      </div>
      <Link to="/product" className="cta-link">
        <Button
          text="EXPLORE THE PRODUCT"
          minWidth={261}
        />
      </Link>
    </section>
  );
};
